import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/settings/privacy')({
  head: () => noIndexRouteHead('settingsPrivacy', 'en'),
  component: () => <SettingsPage section="datenschutz" />,
})
